/**
 * @file 配列フィルタリングクラス
 * @namespace rahmen
 */
/**
 * @module ArrayFilter
 */
export class ArrayFilter {
  /**
   * @constructor
   */
  constructor (keys) {
    this.keys = keys
  }

  /**
   * フィルタ処理
   * @param {Any} value
   * @param {String} search
   * @param {String} item
   */
  filter (value, search, item) {
    const hit = String(value).indexOf(search) !== -1
    return hit
  }
}
